module.exports = __webpack_public_path__ + "img/hc-icon07.25df236e.svg";